import React, { useEffect, useState } from 'react';
import close from "../../../../../../../../assets/close.svg";
import { Link, useLocation } from 'react-router-dom';
import moment from 'moment';
import axiosApi from '../../../../../../../../core/interceptor/interceptor';
import { config } from '../../../../../../../../config';
import SimpleBarReact from 'simplebar-react';

export default function EmailDetailUserModal(props) {
  const [formData, setFormData] = useState({});
  const [bodyPreview, showBodyPreview] = useState(false);
  const [recipients, setRecipients] = useState([]);

  useEffect(() => {
    setFormData({
      recipients_number: props.data.recipients_id,
      subject: props.data.subject,
      body: props.data.body,
      created_at: props.data.created_at,
    });
    getRecipients(props.data.id)
    //eslint-disable-next-line
  }, [])
  /*** closes modal *****/
  const closeModal = () => {
    props.closeModal();
  }
  const search = useLocation().search;
  const leagueId = new URLSearchParams(search).get('leagueId');
  const redirectLink = `/admin/send-email`;

  /***** Get Recipients *****/
  const getRecipients = (messageUserId) => {
    axiosApi.post(`${config.apiUrl}/misc/recipients/${messageUserId}`).then((response) => {
      if (response.data && response.data.data && response.data.data.length) {
        setRecipients(response.data.data);
      }
    }).catch((err) => { 
      console.error(err);
    });
  }

  return <>
    <div className="modal">
      <div className="modal-header">
        <h2>Email Details</h2>
        <p>Sent {moment(formData.created_at).format('M/D/YYYY [at] hh:mm A')}</p>
        <span className="close" onClick={closeModal}>
          <img src={close} alt='close-icon' />
        </span>
      </div>
      <div className="emailArchive-popup">
        <div className="archivePopup-header">
          <div className="text-blk">
            <span className="label">Number of Recipients:</span>
            <span className="value">{formData.recipients_number}</span>
          </div>
          <div className="text-blk">
            <span className="label">Sent to:</span>
            <span className="value">
              {
                recipients.map((recipient, idx) => <span key={idx}>{recipient.name + (idx < recipients.length - 1 ? ', ' : '')}</span>)
              }
            </span>
          </div>
        </div>
        <div className="archivePopup-content">
          <Link onClick={() => props.hideArchBtn(false)} to={{
            pathname: redirectLink,
            state: {
              subject: props.data.subject,
              body: props.data.body,
              leagueId: leagueId,
            },
          }}><button>Re-use Email</button></Link>
          <div className="text-blk">
            <span className="label">Subject: </span>
            <span className="value">{formData.subject}</span>
          </div>
          <div className="body-blk">
            <span>Body</span>
            <div className={`bodyInner-wrapper${!bodyPreview ? ' active' : ''}`}>
              <SimpleBarReact style={{ maxHeight: 300 }}>
                <div className="body-wrapper" >
                  {bodyPreview && <pre style={{ overflowWrap: 'break-word' }} dangerouslySetInnerHTML={{
                    __html: formData.body,
                  }}></pre>}
                  {!bodyPreview && <button onClick={() => showBodyPreview(o => !o)}>Email Body Preview</button>}
                </div>
              </SimpleBarReact>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-footer d-flex">
        <button onClick={closeModal}>close</button>
      </div>
    </div>
  </>
}